import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    bonus: {
      percent: 0,
      cutoff: 5,
    },
    cart: [],
    config: {},
    customer: {
      name: "",
      email: "",
    },
    address: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postal_code: "",
    },
  },
  mutations: {
    add_cart_item(state, item) {
      state.cart.push(item);
    },
    set_config(state, config) {
      state.config = config;
    },
    set_customer(state, customer) {
      state.customer = customer;
    },
    set_address(state, address) {
      state.address = address;
    },
    calculate_bonus(state, item) {
      if (item.condition >= state.bonus.cutoff) {
        return {
          ...item,
          bonus: true,
          bonus_percent: state.bonus.percent,
          bonus_price: (1 + state.bonus.percent / 100) * item.price,
          subtotal: (1 + state.bonus.percent / 100) * item.subtotal,
        };
      } else {
        return { ...item, bonus: false };
      }
    },
    remove_cart_item(state, item) {
      const i = state.cart.indexOf(item);
      state.cart.splice(i, 1);
    },
    clear_cart(state) {
      state.cart = [];
      state.customer = {
        name: "",
        email: "",
      };
      state.address = {
        address1: "",
        address2: "",
        city: "",
        province: "",
        postal_code: "",
      };
    },
  },
  getters: {
    getCart: (state) => state.cart,
    getConfig: (state) => state.config,
    getCustomer: (state) => state.customer,
    getAddress: (state) => state.address,
  },
});
export default store;
